(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Carrossel-avaliativo-vzk"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yafa-evaluative')) {
    customElements.define(
      'yafa-evaluative',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.panels = Array.from(this.querySelectorAll('[data-product-panel]'));
          this.dots = this.querySelector('[data-vzk-slider-dots]');
          this.cursor = this.querySelector('[data-cursor-arraste]');
          this.isDragEnabled = this.dataset.dragEnabled !== 'false';
          this.dots.hidden = !this.slides.length;
          if (this.cursor && (this.slides.length <= 1 || !this.isDragEnabled)) {
            this.cursor.hidden = true;
          }
          if (!this.slides.length) return;
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.createLoop();
          this.index = Math.min(Number(this.dataset.initialIndex) || 0, this.slides.length - 1);
          this.buildPagination();
          this.index = Math.floor((Math.min(this.perPage, this.slides.length) - 1) / 2);
          this.slides.forEach((slide, index) => {
            slide.querySelector('[data-select]').addEventListener(
              'click',
              () => {
                this.go(index);
                this.toggleVideo(index);
              },
              options
            );
            slide.querySelector('.yafa-evaluative__media').addEventListener(
              'click',
              (event) => {
                if (event.target.closest('button') || index !== this.index) return;
                this.toggleVideo(index);
              },
              options
            );
            const preview = slide.querySelector('.yafa-evaluative__preview');
            preview?.addEventListener('playing', () => {
              if (index !== this.index || document.hidden || !this.isVisible || slide.dataset.mainPlayback) {
                preview.pause();
                return;
              }
              slide.classList.add('is-previewing');
              const cover = slide.querySelector('.yafa-evaluative__cover');
              if (cover) cover.hidden = true;
            }, options);
            const video = slide.querySelector('.yafa-evaluative__video');
            if (!video) return;
            video.controls = false;
            const play = slide.querySelector('[data-play]');
            const sound = slide.querySelector('[data-sound]');
            play.addEventListener('click', () => this.toggleVideo(index), options);
            const updatePlayback = () => {
              if (!video.paused && (index !== this.index || document.hidden || this.isVisible === false)) {
                this.resetVideo(slide);
                return;
              }
              slide.classList.toggle('is-playing', !video.paused);
              const cover = slide.querySelector('.yafa-evaluative__cover');
              if (cover && !video.paused) cover.hidden = true;
              play.setAttribute('aria-label', video.paused ? 'Reproduzir vídeo' : 'Pausar vídeo');
              play.querySelector('[data-play-icon]').toggleAttribute('hidden', !video.paused);
              play.querySelector('[data-pause-icon]').toggleAttribute('hidden', video.paused);
            };
            video.addEventListener('play', updatePlayback, options);
            video.addEventListener('pause', updatePlayback, options);
            const finishPlayback = () => {
              this.resetVideo(slide);
              if (index === this.index && this.dataset.advance === 'true') this.go(this.index + 1);
            };
            video.addEventListener(
              'ended',
              finishPlayback,
              options
            );
            sound.addEventListener(
              'click',
              () => {
                video.muted = !video.muted;
                sound.setAttribute('aria-label', video.muted ? 'Ativar som' : 'Desativar som');
                sound.setAttribute('aria-pressed', String(!video.muted));
                sound.querySelector('[data-muted-icon]').toggleAttribute('hidden', !video.muted);
              },
              options
            );
          });
          this.track.addEventListener(
            'scroll',
            () => {
              if (!this.pointer && !this.isAnimatingToCenter) {
                const closest = this.closestElement();
                if (closest) {
                  const newIndex = Number(closest.dataset.loopIndex);
                  if (!isNaN(newIndex) && newIndex !== this.index) {
                    this.setActiveIndex(newIndex);
                  }
                }
              }
              clearTimeout(this.scrollTimer);
              if (!this.pointer && !this.isAnimatingToCenter) this.scrollTimer = setTimeout(() => this.settle(), 200);
            },
            { ...options, passive: true }
          );
          this.addEventListener(
            'pointerenter',
            (event) => {
              if (!this.cursor || this.slides.length <= 1 || !this.isDragEnabled || event.pointerType !== 'mouse') return;
              this.cursor.style.left = `${event.clientX}px`;
              this.cursor.style.top = `${event.clientY}px`;
              this.cursor.classList.add('is-visible');
            },
            options
          );
          this.addEventListener(
            'pointerleave',
            () => {
              if (!this.cursor) return;
              if (!this.pointer?.dragging) {
                this.cursor.classList.remove('is-visible', 'is-dragging', 'is-hidden-interactive');
              }
            },
            options
          );
          this.addEventListener(
            'pointermove',
            (event) => {
              if (this.cursor && this.slides.length > 1 && this.isDragEnabled && event.pointerType === 'mouse') {
                this.cursor.style.left = `${event.clientX}px`;
                this.cursor.style.top = `${event.clientY}px`;
                if (!this.pointer?.dragging) {
                  const isInteractive = event.target.closest(
                    '[data-play], [data-sound], .yafa-evaluative__controls button, .yafa-evaluative__products, .yafa-evaluative__product-card, .swiper-dots-vzk, input, select, textarea'
                  );
                  this.cursor.classList.toggle('is-hidden-interactive', !!isInteractive);
                }
              }
            },
            options
          );
          this.track.addEventListener(
            'pointerdown',
            (event) => {
              if (!this.isDragEnabled || event.pointerType !== 'mouse' || event.button !== 0) return;
              if (event.target.closest('[data-play], [data-sound], .yafa-evaluative__controls button, .yafa-evaluative__products, .swiper-dots-vzk button, input, select, textarea')) return;
              if (this.scrollAnimation) {
                cancelAnimationFrame(this.scrollAnimation);
                this.scrollAnimation = null;
                this.isAnimatingToCenter = false;
                this.track.classList.remove('is-animating');
              }
              clearTimeout(this.scrollTimer);
              this.suppressClickUntil = 0;
              this.pointer = {
                id: event.pointerId,
                x: event.clientX,
                scroll: this.track.scrollLeft,
                dragging: false,
                lastX: event.clientX,
                lastTime: performance.now(),
                velocity: 0,
              };
              if (this.cursor && this.slides.length > 1) {
                this.cursor.classList.add('is-dragging');
                this.cursor.classList.remove('is-hidden-interactive');
              }
            },
            options
          );
          window.addEventListener(
            'pointermove',
            (event) => {
              const pointer = this.pointer;
              if (!pointer || pointer.id !== event.pointerId) return;
              const distance = event.clientX - pointer.x;
              if (!pointer.dragging && Math.abs(distance) <= 6) return;
              if (!pointer.dragging) {
                pointer.dragging = true;
                this.track.classList.add('is-dragging');
                this.track.setPointerCapture(pointer.id);
              }
              event.preventDefault();

              if (this.cursor && this.slides.length > 1) {
                this.cursor.style.left = `${event.clientX}px`;
                this.cursor.style.top = `${event.clientY}px`;
              }

              const now = performance.now();
              const dt = now - pointer.lastTime;
              if (dt > 10) {
                const dx = event.clientX - pointer.lastX;
                pointer.velocity = 0.7 * (dx / dt) + 0.3 * (pointer.velocity || 0);
                pointer.lastX = event.clientX;
                pointer.lastTime = now;
              }

              this.track.scrollLeft = pointer.scroll - distance;
              this.normalizeLoop();
              this.updateActiveOnDrag();
            },
            options
          );
          const endDrag = (event) => {
            if (!this.pointer || this.pointer.id !== event.pointerId) return;
            const { id, dragging, velocity = 0 } = this.pointer;
            this.pointer = null;
            if (this.cursor) {
              this.cursor.classList.remove('is-dragging');
              if (!this.track.matches(':hover')) {
                this.cursor.classList.remove('is-visible', 'is-hidden-interactive');
              }
            }
            if (this.track.hasPointerCapture(id)) this.track.releasePointerCapture(id);
            if (dragging) {
              this.suppressClickUntil = performance.now() + 400;
              this.track.classList.add('is-animating');
              this.track.classList.remove('is-dragging');

              let targetSlide = this.closestElement();
              if (Math.abs(velocity) > 0.25) {
                const direction = velocity < 0 ? 1 : -1;
                const nextIndex =
                  (Number(targetSlide.dataset.loopIndex) + direction + this.slides.length) % this.slides.length;
                const candidates = this.loopSlides.filter((s) => Number(s.dataset.loopIndex) === nextIndex);
                if (candidates.length) {
                  targetSlide = this.closestElement(candidates);
                }
              }

              const targetIndex = Number(targetSlide.dataset.loopIndex);
              this.go(targetIndex, true);
            }
          };
          window.addEventListener('pointerup', endDrag, options);
          window.addEventListener('pointercancel', endDrag, options);
          this.track.addEventListener('lostpointercapture', endDrag, options);
          this.track.addEventListener('dragstart', (event) => event.preventDefault(), options);
          this.track.addEventListener(
            'click',
            (event) => {
              if (performance.now() < this.suppressClickUntil) {
                event.preventDefault();
                event.stopImmediatePropagation();
              }
            },
            { ...options, capture: true }
          );
          this.track.addEventListener(
            'keydown',
            (event) => {
              if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key))
                return;
              event.preventDefault();
              const target =
                event.key === 'Home'
                  ? 0
                  : event.key === 'End'
                  ? this.slides.length - 1
                  : this.index + (event.key === 'ArrowRight' ? 1 : -1);
              this.go(target);
            },
            options
          );
          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
              if (index !== -1) this.go(index, false);
            },
            options
          );
          document.addEventListener(
            'visibilitychange',
            () => {
              if (document.hidden) this.pauseVideos();
              else this.autoplayVideo();
            },
            options
          );
          this.visibilityObserver = new IntersectionObserver((entries) => {
            this.isVisible = entries[0].isIntersecting;
            if (!this.isVisible) this.pauseVideos();
            else this.autoplayVideo();
          });
          this.visibilityObserver.observe(this);
          this.resizeObserver = new ResizeObserver(() => {
            if (this.lastWidth === this.track.clientWidth) return;
            this.lastWidth = this.track.clientWidth;
            this.updateTrackHeight();
            this.buildPagination();
            this.go(this.index, false);
          });
          this.resizeObserver.observe(this.track);
          this.updateTrackHeight();
          requestAnimationFrame(() => this.updateTrackHeight());
          window.addEventListener('load', () => this.updateTrackHeight(), { once: true });
          this.go(this.index, false);
        }
        buildPagination() {
          this.perPage = Math.max(1, parseInt(getComputedStyle(this).getPropertyValue('--reviews-per-page'), 10) || 1);
          const count = Math.ceil(this.slides.length / this.perPage);
          if (this.cursor) {
            this.cursor.hidden = !this.isDragEnabled || this.slides.length <= 1;
            if (this.cursor.hidden) {
              this.cursor.classList.remove('is-visible', 'is-dragging', 'is-hidden-interactive');
            }
          }
          this.dots.replaceChildren();
          this.dots.hidden = count <= 1;
          if (count <= 1) return;
          for (let page = 0; page < count; page += 1) {
            const start = page * this.perPage;
            const length = Math.min(this.perPage, this.slides.length - start);
            const center = start + Math.floor((length - 1) / 2);
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'swiper-dots-vzk__dot';
            dot.setAttribute('aria-label', `Ir para a página ${page + 1} de ${count}`);
            dot.setAttribute('aria-controls', this.track.id);
            dot.addEventListener('click', () => this.go(center), { signal: this.abort.signal });
            this.dots.append(dot);
          }
        }
        createLoop() {
          this.slides.forEach((slide, index) => {
            slide.dataset.loopIndex = index;
          });
          if (this.slides.length > 1) {
            // Covers repeat around the real videos; only the original video can play.
            const copies = Math.ceil(5 / this.slides.length) + 1;
            const before = document.createDocumentFragment();
            const after = document.createDocumentFragment();
            for (const fragment of [before, after]) {
              for (let cycle = 0; cycle < copies; cycle += 1) {
                this.slides.forEach((slide, index) => {
                  const clone = slide.cloneNode(true);
                  clone.dataset.loopClone = '';
                  clone.removeAttribute('id');
                  clone.removeAttribute('data-block-id');
                  clone.removeAttribute('data-shopify-editor-block');
                  clone.setAttribute('aria-hidden', 'true');
                  clone.classList.remove('is-playing', 'is-previewing');
                  clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
                  clone.querySelectorAll('video, [data-play], [data-sound]').forEach((element) => element.remove());
                  const cover = clone.querySelector('.yafa-evaluative__cover');
                  if (cover) cover.hidden = false;
                  const select = clone.querySelector('[data-select]');
                  select.hidden = false;
                  select.tabIndex = -1;
                  select.addEventListener(
                    'click',
                    () => {
                      this.go(index, false);
                      this.toggleVideo(index);
                    },
                    { signal: this.abort.signal }
                  );
                  fragment.append(clone);
                });
              }
            }
            this.track.prepend(before);
            this.track.append(after);
            this.track.classList.add('is-looping');
          }
          this.loopSlides = Array.from(this.track.querySelectorAll('[data-slide]'));
        }
        closestElement(elements = this.loopSlides) {
          const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
          return elements.reduce((closest, slide) => {
            const rect = slide.getBoundingClientRect();
            const previous = closest.getBoundingClientRect();
            return Math.abs(rect.left + rect.width / 2 - center) < Math.abs(previous.left + previous.width / 2 - center)
              ? slide
              : closest;
          });
        }
        normalizeLoop() {
          const closest = this.closestElement();
          if (!closest.hasAttribute('data-loop-clone')) return;
          const original = this.slides[Number(closest.dataset.loopIndex)];
          const shift = original.getBoundingClientRect().left - closest.getBoundingClientRect().left;
          this.track.scrollLeft += shift;
          if (this.pointer) this.pointer.scroll += shift;
        }
        closestSlide() {
          return Number(this.closestElement().dataset.loopIndex);
        }
        settle() {
          if (this.isAnimatingToCenter || this.pointer) return;
          const closest = this.closestElement();
          if (!closest) return;
          const index = Number(closest.dataset.loopIndex);
          if (closest.hasAttribute('data-loop-clone')) {
            this.normalizeLoop();
          }
          if (index !== this.index) {
            this.go(index, true);
          }
        }
        toggleVideo(index) {
          cancelAnimationFrame(this.autoplayFrame);
          const slide = this.slides[index];
          const video = slide?.querySelector('.yafa-evaluative__video');
          if (!video) return;
          slide.dataset.mainPlayback = 'true';
          const preview = slide.querySelector('.yafa-evaluative__preview');
          preview?.pause();
          slide.classList.remove('is-previewing');
          if (video.paused)
            video.play().catch(() => {
              this.querySelector('[data-status]').textContent = 'Não foi possível reproduzir o vídeo. Tente novamente.';
            });
          else video.pause();
        }
        updateActiveOnDrag() {
          const closest = this.closestElement();
          if (!closest) return;
          const newIndex = Number(closest.dataset.loopIndex);
          if (isNaN(newIndex) || newIndex === this.index) return;

          const rectBefore = closest.getBoundingClientRect().left;
          this.setActiveIndex(newIndex);
          const rectAfter = closest.getBoundingClientRect().left;
          const shift = rectAfter - rectBefore;
          if (shift !== 0) {
            this.track.scrollLeft += shift;
            if (this.pointer) this.pointer.scroll += shift;
          }
        }
        setActiveIndex(newIndex) {
          const nextIndex = ((newIndex % this.slides.length) + this.slides.length) % this.slides.length;
          if (this.index === nextIndex && this.hasInitializedActive) return;
          this.hasInitializedActive = true;
          this.index = nextIndex;
          this.loopSlides?.forEach((slide) => {
            slide.classList.toggle('is-active', Number(slide.dataset.loopIndex) === this.index);
          });
          this.slides.forEach((slide, position) => {
            const active = position === this.index;
            slide.classList.toggle('is-active', active);
            const select = slide.querySelector('[data-select]');
            if (select) select.hidden = active;
            slide.querySelectorAll('[data-play], [data-sound]').forEach((button) => {
              button.hidden = !active;
            });
            if (!active) this.resetVideo(slide);
            if (this.panels[position]) this.panels[position].hidden = !active;
          });
          const currentPage = Math.floor(this.index / this.perPage);
          Array.from(this.dots?.children || []).forEach((dot, page) => {
            if (page === currentPage) dot.setAttribute('aria-current', 'page');
            else dot.removeAttribute('aria-current');
          });
          this.autoplayVideo();
        }
        resetVideo(slide) {
          slide.querySelectorAll('video').forEach((video) => {
            video.pause();
            if (video.readyState > 0) video.currentTime = 0;
          });
          delete slide.dataset.mainPlayback;
          const cover = slide.querySelector('.yafa-evaluative__cover');
          if (cover) cover.hidden = false;
          slide.classList.remove('is-playing', 'is-previewing');
        }
        autoplayVideo() {
          cancelAnimationFrame(this.autoplayFrame);
          if (this.dataset.autoplay !== 'true' || !this.isVisible || document.hidden) return;
          this.autoplayFrame = requestAnimationFrame(() => {
            const slide = this.slides[this.index];
            if (!slide || slide.dataset.mainPlayback) return;
            const video = slide.querySelector('.yafa-evaluative__preview') || slide.querySelector('.yafa-evaluative__video');
            if (!video || !video.paused || !this.isVisible || document.hidden) return;
            video.muted = true;
            const sound = slide.querySelector('[data-sound]');
            sound?.setAttribute('aria-label', 'Ativar som');
            sound?.setAttribute('aria-pressed', 'false');
            sound?.querySelector('[data-muted-icon]')?.removeAttribute('hidden');
            video.play().catch(() => {});
          });
        }
        smoothScrollTo(targetLeft, customDuration) {
          if (this.scrollAnimation) {
            cancelAnimationFrame(this.scrollAnimation);
            this.scrollAnimation = null;
          }

          if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.track.scrollLeft = targetLeft;
            return;
          }

          const startLeft = this.track.scrollLeft;
          const distance = targetLeft - startLeft;
          if (Math.abs(distance) < 1) {
            this.track.scrollLeft = targetLeft;
            return;
          }

          const duration = customDuration || Math.min(500, Math.max(300, Math.abs(distance) * 1.3));
          this.isAnimatingToCenter = true;
          this.track.classList.add('is-animating');
          const startTime = performance.now();
          const easeOut = (t) => Math.sin((t * Math.PI) / 2);

          const step = (now) => {
            const elapsed = now - startTime;
            const progress = Math.min(1, elapsed / duration);
            const eased = easeOut(progress);

            this.track.scrollLeft = startLeft + distance * eased;

            if (progress < 1) {
              this.scrollAnimation = requestAnimationFrame(step);
            } else {
              this.track.scrollLeft = targetLeft;
              this.scrollAnimation = null;
              this.isAnimatingToCenter = false;
              this.track.classList.remove('is-animating');
              this.normalizeLoop();
            }
          };

          this.scrollAnimation = requestAnimationFrame(step);
        }
        updateTrackHeight() {
          const sample = this.slides[0];
          if (!sample) return;
          const slideRect = sample.getBoundingClientRect();
          if (!slideRect.width) return;
          const baseWidth = matchMedia('(max-width: 749px)').matches
            ? this.track.clientWidth * 0.62
            : sample.classList.contains('is-active') ? slideRect.width / 1.16 : slideRect.width;
          const activeHeight = baseWidth * 1.16 * (548 / 320);
          const trackMinHeight = Math.ceil(activeHeight + 16);
          this.style.setProperty('--track-min-height', `${trackMinHeight}px`);
          this.track.style.minHeight = `${trackMinHeight}px`;

          let maxPanelHeight = 0;
          this.panels.forEach((panel) => {
            const product = panel.querySelector('.yafa-evaluative__product');
            if (product) {
              const prevHidden = panel.hidden;
              panel.hidden = false;
              const h = panel.offsetHeight;
              if (h > maxPanelHeight) maxPanelHeight = h;
              panel.hidden = prevHidden;
            }
          });
          const productsContainer = this.querySelector('.yafa-evaluative__products');
          if (productsContainer && maxPanelHeight > 0) {
            productsContainer.style.minHeight = `${maxPanelHeight}px`;
          }
        }
        go(index, smooth = true) {
          this.setActiveIndex(index);
          const matchingSlides = this.loopSlides?.filter((slide) => Number(slide.dataset.loopIndex) === this.index);
          const target =
            matchingSlides && matchingSlides.length ? this.closestElement(matchingSlides) : this.slides[this.index];
          if (!target) return;
          const slideRect = target.getBoundingClientRect();
          const trackRect = this.track.getBoundingClientRect();
          const left =
            this.track.scrollLeft + slideRect.left + slideRect.width / 2 - trackRect.left - this.track.clientWidth / 2;
          if (smooth) {
            this.smoothScrollTo(left, 450);
            this.querySelector('[data-status]').textContent = `Vídeo ${this.index + 1} de ${this.slides.length}`;
          } else {
            if (this.scrollAnimation) {
              cancelAnimationFrame(this.scrollAnimation);
              this.scrollAnimation = null;
              this.isAnimatingToCenter = false;
              this.track.classList.remove('is-animating');
            }
            this.track.scrollLeft = left;
          }
        }
        pauseVideos() {
          cancelAnimationFrame(this.autoplayFrame);
          this.querySelectorAll('video').forEach((video) => video.pause());
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
          this.visibilityObserver?.disconnect();
          clearTimeout(this.scrollTimer);
          if (this.scrollAnimation) {
            cancelAnimationFrame(this.scrollAnimation);
            this.scrollAnimation = null;
          }
          this.pointer = null;
          this.track?.classList.remove('is-dragging');
          this.track?.classList.remove('is-animating');
          this.pauseVideos();
          this.track?.querySelectorAll('[data-loop-clone]').forEach((slide) => slide.remove());
          this.track?.classList.remove('is-looping');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["FAQ-vzk"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion-vzk')) {
    class FaqAccordionVzk extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('details.yafa-faq__item'));

        this.items.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (this.dataset.singleOpen === 'true' && item.open) {
              this.items.forEach((other) => {
                if (other !== item && other.open) {
                  other.open = false;
                }
              });
            }
          });
        });
      }
    }
    customElements.define('faq-accordion-vzk', FaqAccordionVzk);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["InstagramMoscaic-vzk"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yafa-instagram-marquee')) {
    customElements.define(
      'yafa-instagram-marquee',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.firstGroup = this.querySelector('[data-group]');
          if (!this.track || !this.firstGroup) return;

          const speedSec = parseFloat(this.dataset.speed) || 28;
          this.speedMs = speedSec * 1000;

          this.currentX = 0;
          this.cycleWidth = 0;
          this.isPointerDown = false;
          this.isDragging = false;
          this.hasMoved = false;
          this.isHovered = false;
          this.startX = 0;
          this.startY = 0;
          this.lastClientX = 0;
          this.lastTimestamp = 0;
          this.velocityX = 0;
          this.lastFrameTime = 0;
          this.animationFrameId = null;

          this.updateDimensions();
          this.track.classList.add('js-marquee-active');

          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onMouseEnter = (e) => {
            if (e.pointerType !== 'touch') this.isHovered = true;
          };
          this.onMouseLeave = () => {
            this.isHovered = false;
          };
          this.onClickCapture = this.onClickCapture.bind(this);

          this.track.addEventListener('pointerdown', this.onPointerDown);
          window.addEventListener('pointermove', this.onPointerMove, { passive: false });
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
          this.addEventListener('mouseenter', this.onMouseEnter);
          this.addEventListener('mouseleave', this.onMouseLeave);
          this.track.addEventListener('click', this.onClickCapture, true);

          if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(() => {
              this.updateDimensions();
            });
            this.resizeObserver.observe(this.firstGroup);
          }

          this.tick = this.tick.bind(this);
          this.animationFrameId = requestAnimationFrame(this.tick);
        }

        disconnectedCallback() {
          if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
        }

        updateDimensions() {
          const gap = parseFloat(getComputedStyle(this.track).gap) || 8;
          const groupWidth = this.firstGroup.getBoundingClientRect().width;
          if (groupWidth > 0) {
            this.cycleWidth = groupWidth + gap;
          }
        }

        onPointerDown(e) {
          if (e.button !== 0 && e.pointerType === 'mouse') return;
          this.isPointerDown = true;
          this.isDragging = false;
          this.hasMoved = false;
          this.startX = e.clientX;
          this.startY = e.clientY;
          this.lastClientX = e.clientX;
          this.lastTimestamp = performance.now();
          this.velocityX = 0;
        }

        onPointerMove(e) {
          if (!this.isPointerDown) return;
          const dx = e.clientX - this.startX;
          const dy = e.clientY - this.startY;

          if (!this.isDragging) {
            if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
              if (Math.abs(dx) > Math.abs(dy)) {
                this.isDragging = true;
                this.hasMoved = true;
                this.classList.add('is-dragging');
                try {
                  this.track.setPointerCapture(e.pointerId);
                } catch (err) {}
              } else {
                this.isPointerDown = false;
                return;
              }
            }
          }

          if (this.isDragging) {
            if (e.cancelable) e.preventDefault();
            const now = performance.now();
            const dt = now - this.lastTimestamp || 16;
            const moveDelta = e.clientX - this.lastClientX;

            this.currentX += moveDelta;
            this.normalizeCurrentX();

            this.velocityX = moveDelta / dt;
            this.lastClientX = e.clientX;
            this.lastTimestamp = now;

            this.track.style.transform = `translate3d(${this.currentX}px, 0, 0)`;
          }
        }

        onPointerUp(e) {
          if (!this.isPointerDown && !this.isDragging) return;
          this.isPointerDown = false;
          this.classList.remove('is-dragging');

          if (this.track.hasPointerCapture && e.pointerId && this.track.hasPointerCapture(e.pointerId)) {
            try {
              this.track.releasePointerCapture(e.pointerId);
            } catch (err) {}
          }

          if (this.isDragging) {
            if (Math.abs(this.velocityX) > 2) {
              this.velocityX = Math.sign(this.velocityX) * 2;
            }
          }

          setTimeout(() => {
            this.isDragging = false;
            this.hasMoved = false;
          }, 60);
        }

        onClickCapture(e) {
          if (this.hasMoved || this.isDragging) {
            e.preventDefault();
            e.stopPropagation();
          }
        }

        normalizeCurrentX() {
          if (this.cycleWidth <= 0) return;
          while (this.currentX <= -this.cycleWidth) {
            this.currentX += this.cycleWidth;
          }
          while (this.currentX > 0) {
            this.currentX -= this.cycleWidth;
          }
        }

        tick(timestamp) {
          if (!this.lastFrameTime) this.lastFrameTime = timestamp;
          const dt = Math.min(timestamp - this.lastFrameTime, 64);
          this.lastFrameTime = timestamp;

          if (this.cycleWidth > 0 && !this.isPointerDown) {
            if (Math.abs(this.velocityX) > 0.05) {
              this.currentX += this.velocityX * dt;
              this.velocityX *= 0.94;
            } else {
              this.velocityX = 0;
              const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              if (!this.isHovered && !isReducedMotion) {
                const baseSpeed = this.cycleWidth / this.speedMs;
                this.currentX -= baseSpeed * dt;
              }
            }

            this.normalizeCurrentX();
            this.track.style.transform = `translate3d(${this.currentX}px, 0, 0)`;
          }

          this.animationFrameId = requestAnimationFrame(this.tick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Popup-desconto-vzk"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yafa-discount-popup')) {
    customElements.define(
      'yafa-discount-popup',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-popup-dialog]');
          this.trigger = this.querySelector('[data-popup-trigger]');
          if (!this.dialog) return;
          this.hasSuccess = Boolean(this.querySelector('[data-popup-success]'));
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.storageKey = `yafa_discount_${this.dataset.sectionId}`;
          this.querySelector('[data-popup-close]')?.addEventListener('click', () => this.close(), options);
          this.trigger?.addEventListener('click', () => this.open(), options);
          this.dialog.addEventListener(
            'click',
            (event) => {
              if (event.target === this.dialog) this.close();
            },
            options
          );
          this.dialog.addEventListener(
            'cancel',
            (event) => {
              event.preventDefault();
              this.close();
            },
            options
          );
          this.dialog.addEventListener('close', () => this.afterClose(), options);
          document.addEventListener(
            'yafa:discount:open',
            (event) => {
              if (!event.detail?.sectionId || String(event.detail.sectionId) === String(this.dataset.sectionId))
                this.open();
            },
            options
          );
          document.addEventListener(
            'shopify:section:select',
            (event) => {
              if (String(event.detail.sectionId) === String(this.dataset.sectionId)) this.open();
            },
            options
          );

          if (this.hasSuccess) {
            this.setStored('submitted');
            this.open();
            requestAnimationFrame(() => this.querySelector('[data-popup-success]')?.focus());
            return;
          }

          if (this.dataset.designMode === 'true') {
            this.open();
            return;
          }

          if (this.getStored() === 'submitted') return;
          if (this.dataset.autoOpen === 'true' && !this.getSessionDismissed()) {
            const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
            this.timer = window.setTimeout(() => this.open(), delay);
          } else {
            this.showTrigger();
          }
        }

        getStored() {
          try {
            return localStorage.getItem(this.storageKey) || '';
          } catch (error) {
            return '';
          }
        }

        setStored(value) {
          try {
            localStorage.setItem(this.storageKey, value);
          } catch (error) {}
        }

        getSessionDismissed() {
          try {
            return sessionStorage.getItem(`${this.storageKey}_dismissed`) === 'true';
          } catch (error) {
            return false;
          }
        }

        setSessionDismissed() {
          try {
            sessionStorage.setItem(`${this.storageKey}_dismissed`, 'true');
          } catch (error) {}
        }

        open() {
          window.clearTimeout(this.timer);
          if (this.getStored() === 'submitted' && !this.hasSuccess && this.dataset.designMode !== 'true') return;
          if (this.dialog.open) return;
          this.previousFocus = document.activeElement;
          this.trigger?.setAttribute('hidden', '');
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          requestAnimationFrame(() => this.dialog.querySelector('input, button')?.focus());
        }

        close() {
          if (!this.dialog.open) return;
          this.setSessionDismissed();
          this.dialog.close();
        }

        afterClose() {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.showTrigger();
          this.previousFocus?.focus?.();
        }

        showTrigger() {
          if (!this.trigger || this.getStored() === 'submitted') return;
          this.trigger.removeAttribute('hidden');
        }

        disconnectedCallback() {
          this.abort?.abort();
          window.clearTimeout(this.timer);
          if (this.dialog?.open) this.dialog.close();
          document.documentElement.style.overflow = this.previousOverflow || '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Quem-somos-vzk"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const observedSections = new WeakMap();
    let updateFrame = null;
    const updateTrailClearance = (section) => {
      const layout = section.querySelector('.yafa-about__layout');
      const card = section.querySelector('.yafa-about__card');
      const content = section.querySelector('.yafa-about__card-content');
      const trail = section.querySelector('.yafa-about__trail');
      if (!layout || !card || !content || !trail) return;
      layout.style.setProperty('--yafa-about-trail-clearance', '0px');
      if (!trail.getClientRects().length) return;
      const cardBounds = card.getBoundingClientRect();
      const contentBounds = content.getBoundingClientRect();
      const trailBounds = trail.getBoundingClientRect();
      // O primeiro trecho sobre o card começa no laço, abaixo do topo do SVG.
      const loopTop = trailBounds.top + trailBounds.height * 0.24;
      const clearance = Math.max(
        0,
        Math.ceil(contentBounds.bottom + 16 - loopTop),
        Math.ceil(contentBounds.bottom + 24 - cardBounds.bottom)
      );
      layout.style.setProperty('--yafa-about-trail-clearance', `${clearance}px`);
    };
    const scheduleTrailUpdate = () => {
      if (updateFrame !== null) return;
      updateFrame = requestAnimationFrame(() => {
        updateFrame = null;
        document.querySelectorAll('.yafa-about').forEach(updateTrailClearance);
      });
    };
    const connectSections = () => {
      document.querySelectorAll('.yafa-about').forEach((section) => {
        if (!observedSections.has(section) && typeof ResizeObserver !== 'undefined') {
          const content = section.querySelector('.yafa-about__card-content');
          if (content) {
            const observer = new ResizeObserver(scheduleTrailUpdate);
            observer.observe(content);
            observedSections.set(section, observer);
          }
        }
        updateTrailClearance(section);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', connectSections, { once: true });
    } else {
      connectSections();
    }
    window.addEventListener('resize', scheduleTrailUpdate, { passive: true });
    window.addEventListener('load', scheduleTrailUpdate, { once: true });
    document.addEventListener('shopify:section:load', connectSections);
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('.yafa-about');
      const observer = section && observedSections.get(section);
      if (observer) {
        observer.disconnect();
        observedSections.delete(section);
      }
    });
    if (document.fonts) document.fonts.ready.then(scheduleTrailUpdate);
  })();
  const initTrailPlanes = () => {
  document.querySelectorAll('.yafa-about').forEach((section) => {
    const trails = section.querySelectorAll('.yafa-about__trail, .yafa-about__mobile-trail');
    trails.forEach((trail) => {
      const path = trail.querySelector('svg path');
      const plane = trail.querySelector('.yafa-about__plane');
      if (!path || !plane) return;
      if (plane.dataset.initialized === 'true') return;
      plane.dataset.initialized = 'true';
      const duration = 10000;
      const pathLength = path.getTotalLength();
      let startTime = null;
      const animatePlane = (time) => {
        if (!startTime) startTime = time;
        const progress = ((time - startTime) % duration) / duration;
        const distance = pathLength * progress;
        const point = path.getPointAtLength(distance);
        const nextPoint = path.getPointAtLength(Math.min(distance + 2, pathLength));
        const matrix = path.getScreenCTM();
        if (matrix && trail.getClientRects().length) {
          const svg = path.ownerSVGElement;
          const current = svg.createSVGPoint();
          const next = svg.createSVGPoint();
          current.x = point.x;
          current.y = point.y;
          next.x = nextPoint.x;
          next.y = nextPoint.y;
          const screenPoint = current.matrixTransform(matrix);
          const screenNextPoint = next.matrixTransform(matrix);
          const trailRect = trail.getBoundingClientRect();
          const x = screenPoint.x - trailRect.left;
          const y = screenPoint.y - trailRect.top;
          const angle = Math.atan2(
            screenNextPoint.y - screenPoint.y,
            screenNextPoint.x - screenPoint.x
          ) * (180 / Math.PI);
          plane.style.transform = `translate(calc(${x}px - 50%), calc(${y}px - 50%)) rotate(${angle}deg)`;
        }
        requestAnimationFrame(animatePlane);
      };
      requestAnimationFrame(animatePlane);
    });
  });
};
initTrailPlanes();
document.addEventListener('shopify:section:load', initTrailPlanes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SliderdeProdutos-vzk"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-slider-vzk')) {
    class ProductSliderVzk extends HTMLElement {
      isMobileGrid() {
        return this.mobileGrid?.matches && this.dataset.mobileLayout !== 'slider';
      }

      connectedCallback() {
        this.viewport = this.querySelector('[data-vzk-slider-viewport]');
        this.tracks = Array.from(this.querySelectorAll('[data-vzk-slider-track]'));
        this.track = this.tracks[0];
        this.slides = Array.from(this.track?.querySelectorAll('[data-vzk-slider-slide]:not([data-loop-clone])') || []);
        this.dots = this.querySelector('[data-vzk-slider-dots]');
        this.categories = this.querySelector('[data-vzk-slider-categories]');
        this.categoryButtons = Array.from(this.querySelectorAll('[data-vzk-category-button]'));
        this.cursor = this.querySelector('[data-cursor-arraste]');
        this.isInfinite = this.dataset.infinite === 'true' && this.slides.length > 1;
        this.mobileGrid = window.matchMedia('(max-width: 749px)');

        if (!this.viewport || !this.track || !this.dots || this.slides.length === 0) return;

        this.onScroll = this.onScroll.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onPointerEnter = this.onPointerEnter.bind(this);
        this.onPointerLeave = this.onPointerLeave.bind(this);
        this.onClickCapture = this.onClickCapture.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onCategoryClick = this.onCategoryClick.bind(this);
        this.buildPagination = this.buildPagination.bind(this);
        this.updateActiveSlide = this.updateActiveSlide.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);

        this.tracks.forEach((track) => {
          track.querySelectorAll('[data-vzk-slider-slide]:not([data-loop-clone])').forEach((slide, index) => {
            slide.dataset.loopIndex = String(index);
          });
        });

        if (this.isInfinite && !this.isMobileGrid()) {
          this.tracks.forEach((track) => this.createLoopForTrack(track));
          this.loopSlides = Array.from(this.track.querySelectorAll('[data-vzk-slider-slide]'));
        } else {
          this.loopSlides = this.slides;
        }

        this.bindDesktopHover();

        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('pointerenter', this.onPointerEnter);
        this.viewport.addEventListener('pointerleave', this.onPointerLeave);
        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        this.viewport.addEventListener('lostpointercapture', this.onPointerUp);
        this.viewport.addEventListener('click', this.onClickCapture, true);
        this.viewport.addEventListener('dragstart', this.onDragStart);
        this.viewport.addEventListener('keydown', this.onKeyDown);
        this.categories?.addEventListener('click', this.onCategoryClick);
        this.syncCardHeight = this.syncCardHeight.bind(this);
        this.mobileGrid.addEventListener('change', this.onLayoutChange);

        this.resizeObserver = new ResizeObserver(() => {
          this.buildPagination();
          this.updateActiveSlide();
          this.syncCardHeight();
        });
        this.resizeObserver.observe(this.viewport);

        this.buildPagination();
        this.initPosition();
        this.updateActiveSlide();
        this.syncCardHeight();
        requestAnimationFrame(() => {
          this.initPosition();
          this.updateActiveSlide();
          this.syncCardHeight();
        });
        window.addEventListener(
          'load',
          () => {
            this.initPosition();
            this.updateActiveSlide();
            this.syncCardHeight();
          },
          { once: true }
        );
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.onScroll);
        this.viewport?.removeEventListener('pointerenter', this.onPointerEnter);
        this.viewport?.removeEventListener('pointerleave', this.onPointerLeave);
        this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        this.viewport?.removeEventListener('lostpointercapture', this.onPointerUp);
        this.viewport?.removeEventListener('click', this.onClickCapture, true);
        this.viewport?.removeEventListener('dragstart', this.onDragStart);
        this.viewport?.removeEventListener('keydown', this.onKeyDown);
        this.categories?.removeEventListener('click', this.onCategoryClick);
        this.mobileGrid?.removeEventListener('change', this.onLayoutChange);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        if (this.scrollAnimation) {
          cancelAnimationFrame(this.scrollAnimation);
          this.scrollAnimation = null;
        }
        clearTimeout(this.scrollTimer);
        this.tracks.forEach((track) => {
          track.querySelectorAll('[data-loop-clone]').forEach((slide) => slide.remove());
          track.classList.remove('is-looping');
        });
      }

      onLayoutChange() {
        this.viewport.scrollLeft = 0;
        this.activeSlide?.classList.remove('is-active');
        this.activeSlide = null;
        this.pageCount = undefined;

        if (this.isMobileGrid()) {
          if (this.scrollAnimation) cancelAnimationFrame(this.scrollAnimation);
          this.scrollAnimation = null;
          this.isAnimating = false;
          this.pointer = null;
          this.viewport.classList.remove('is-animating', 'is-dragging');
          this.tracks.forEach((track) => {
            track.querySelectorAll('[data-loop-clone]').forEach((slide) => slide.remove());
            track.classList.remove('is-looping');
            track.querySelectorAll('[data-vzk-slider-slide]').forEach((slide) => {
              slide.classList.remove('is-active');
            });
          });
          this.loopSlides = this.slides;
        } else if (this.isInfinite) {
          this.tracks.forEach((track) => this.createLoopForTrack(track));
          this.loopSlides = Array.from(this.track.querySelectorAll('[data-vzk-slider-slide]'));
        } else {
          this.loopSlides = this.slides;
        }

        this.buildPagination();
        this.syncCardHeight();
        if (!this.isMobileGrid()) {
          this.initPosition();
          this.updateActiveSlide();
        }
      }

      syncCardHeight() {
        const firstCard = this.querySelector('.vzk-product-card');
        if (firstCard && firstCard.offsetHeight > 0) {
          this.style.setProperty('--vzk-product-card-height', `${firstCard.offsetHeight}px`);
        }
      }

      bindDesktopHover() {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  this.slides.forEach((slide) => {
    slide.addEventListener('mouseenter', () => {
      this.slides.forEach((item) => {
        item.classList.remove('is-active');
      });

      slide.classList.add('is-active');
      slide.classList.add('is-activating');

      setTimeout(() => {
        slide.classList.remove('is-activating');
      }, 150);
    });

    slide.addEventListener('mouseleave', () => {
      this.slides.forEach((item) => {
        item.classList.remove('is-active');
      });

      if (this.activeSlide) {
        this.activeSlide.classList.add('is-active');
      }
    });
  });
}

      createLoopForTrack(track) {
        const originalSlides = Array.from(track.querySelectorAll('[data-vzk-slider-slide]:not([data-loop-clone])'));
        if (originalSlides.length <= 1) return;

        originalSlides.forEach((slide, index) => {
          slide.dataset.loopIndex = String(index);
        });

        const existingClones = track.querySelectorAll('[data-loop-clone]');
        if (existingClones.length > 0) return;

        const copies = Math.ceil(5 / originalSlides.length) + 1;
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();

        for (const fragment of [before, after]) {
          for (let cycle = 0; cycle < copies; cycle += 1) {
            originalSlides.forEach((slide, index) => {
              const clone = slide.cloneNode(true);
              clone.dataset.loopClone = '';
              clone.dataset.loopIndex = String(index);
              clone.removeAttribute('id');
              clone.removeAttribute('data-block-id');
              clone.removeAttribute('data-shopify-editor-block');
              clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
              fragment.append(clone);
            });
          }
        }

        track.prepend(before);
        track.append(after);
        track.classList.add('is-looping');
      }

      getSlideScrollLeft(slide) {
        if (!slide) return this.viewport.scrollLeft;
        const isMobile = window.innerWidth <= 749;
        const slideRect = slide.getBoundingClientRect();
        const viewportRect = this.viewport.getBoundingClientRect();
        if (isMobile) {
          const focal = viewportRect.left + parseFloat(getComputedStyle(this.viewport).paddingLeft || 0);
          const slideFocal = slideRect.left;
          return this.viewport.scrollLeft + (slideFocal - focal);
        }
        return this.viewport.scrollLeft + (slideRect.left - viewportRect.left);
      }

      initPosition() {
        if (this.isMobileGrid()) return;
        if (this.isInfinite && this.slides.length > 1 && this.slides[0]) {
          const targetLeft = this.getSlideScrollLeft(this.slides[0]);
          if (Math.abs(this.viewport.scrollLeft - targetLeft) > 5) {
            this.viewport.scrollLeft = targetLeft;
          }
        }
      }

      onCategoryClick(event) {
        const button = event.target.closest('[data-vzk-category-button]');
        if (!button || !this.categories?.contains(button)) return;
        this.selectCategory(Number(button.dataset.categoryIndex));
      }

      selectCategory(index) {
        const nextTrack = this.tracks[index];
        if (!nextTrack || nextTrack === this.track) return;

        this.tracks.forEach((track, trackIndex) => {
          track.hidden = trackIndex !== index;
        });
        this.categoryButtons.forEach((button, buttonIndex) => {
          const active = buttonIndex === index;
          button.classList.toggle('yafa-category__item--filled', active);
          button.classList.toggle('yafa-category__item--dotted', !active);
          button.setAttribute('aria-pressed', String(active));
        });

        this.track = nextTrack;
        this.slides = Array.from(nextTrack.querySelectorAll('[data-vzk-slider-slide]:not([data-loop-clone])'));
        this.activeSlide?.classList.remove('is-active');
        this.activeSlide = null;
        if (this.isMobileGrid()) {
          this.loopSlides = this.slides;
          this.pageCount = undefined;
          this.buildPagination();
          return;
        }
        if (this.isInfinite) {
          this.createLoopForTrack(this.track);
          this.loopSlides = Array.from(this.track.querySelectorAll('[data-vzk-slider-slide]'));
          requestAnimationFrame(() => {
            if (this.slides[0]) {
              this.viewport.scrollLeft = this.getSlideScrollLeft(this.slides[0]);
            }
            this.updatePagination();
            this.updateActiveSlide();
          });
        } else {
          this.loopSlides = this.slides;
          this.viewport.scrollLeft = 0;
          this.updateActiveSlide();
        }

        this.pageCount = undefined;
        this.buildPagination();
      }

      getMetrics() {
        const firstSlide = this.slides[0];
        if (!firstSlide) return { step: 0, perPage: 1, pageCount: 1, positions: [0] };
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const slideWidth = firstSlide.getBoundingClientRect().width || firstSlide.offsetWidth || 1;
        const step = slideWidth + gap;
        const perPage = Math.max(1, Math.floor((this.viewport.clientWidth + gap) / step) || 1);
        const pageCount = Math.ceil(this.slides.length / perPage);
        const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const positions = Array.from({ length: pageCount }, (_, index) => {
          if (index === 0) return 0;
          const slide = this.slides[Math.min(index * perPage, this.slides.length - 1)];
          return Math.max(0, Math.min(slide ? slide.offsetLeft : 0, maxScroll));
        });
        return { step, perPage, pageCount, positions };
      }

      buildPagination() {
        if (this.isMobileGrid()) {
          this.dots.hidden = true;
          if (this.cursor) this.cursor.hidden = true;
          return;
        }
        const metrics = this.getMetrics();
        if (this.cursor) {
          const showCursor =
            !this.mobileGrid.matches &&
            this.dataset.dragEnabled === 'true' &&
            (this.isInfinite ? this.slides.length > 1 : metrics.pageCount > 1);
          this.cursor.hidden = !showCursor;
          if (!showCursor) {
            this.cursor.classList.remove('is-visible', 'is-dragging', 'is-hidden-interactive');
          }
        }
        if (metrics.pageCount === this.pageCount) {
          this.updatePagination();
          return;
        }

        this.pageCount = metrics.pageCount;
        this.dots.replaceChildren();
        this.dots.hidden = metrics.pageCount <= 1;

        for (let index = 0; index < metrics.pageCount; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'swiper-dots-vzk__dot';
          dot.setAttribute('aria-label', `Ir para a página ${index + 1}`);
          dot.setAttribute('aria-controls', this.viewport.id);
          dot.addEventListener('click', () => this.goToPage(index));
          this.dots.append(dot);
        }

        this.updatePagination();
      }

      closestElement(elements = this.loopSlides, focalOverride) {
        if (!elements || elements.length === 0) return null;
        const isMobile = window.innerWidth <= 749;
        const viewportRect = this.viewport.getBoundingClientRect();
        const mobileStart = viewportRect.left + parseFloat(getComputedStyle(this.viewport).paddingLeft || 0);
        const focal =
          focalOverride !== undefined
            ? focalOverride
            : isMobile
            ? mobileStart
            : viewportRect.left;

        return elements.reduce((closest, slide) => {
          const rect = slide.getBoundingClientRect();
          const prevRect = closest.getBoundingClientRect();
          const slidePoint = rect.left;
          const prevPoint = prevRect.left;
          return Math.abs(slidePoint - focal) < Math.abs(prevPoint - focal) ? slide : closest;
        });
      }

      normalizeLoop() {
        if (!this.isInfinite || this.slides.length <= 1 || this.isNormalizing) return;
        const closest = this.closestElement();
        if (!closest || !closest.hasAttribute('data-loop-clone')) return;
        const originalIndex = Number(closest.dataset.loopIndex);
        const original = this.slides[originalIndex];
        if (!original) return;
        const shift = original.getBoundingClientRect().left - closest.getBoundingClientRect().left;
        if (Math.abs(shift) > 0.5) {
          this.isNormalizing = true;
          const prevBehavior = this.viewport.style.scrollBehavior;
          const prevSnap = this.viewport.style.scrollSnapType;
          this.viewport.style.scrollBehavior = 'auto';
          this.viewport.style.scrollSnapType = 'none';
          this.viewport.scrollLeft += shift;
          if (this.pointer) {
            this.pointer.startScroll += shift;
          }
          void this.viewport.scrollLeft;
          this.viewport.style.scrollBehavior = prevBehavior;
          this.viewport.style.scrollSnapType = prevSnap;
          requestAnimationFrame(() => {
            this.isNormalizing = false;
          });
        }
      }

      goToPage(index) {
        const { positions, perPage } = this.getMetrics();
        this.setActiveDot(index);
        const isMobile = window.innerWidth <= 749;

        if (!this.isInfinite) {
          if (isMobile) {
            const target = this.slides[index];
            if (target) {
              const targetLeft = this.getSlideScrollLeft(target);
              this.smoothScrollTo(targetLeft, 350);
            }
          } else {
            this.viewport.scrollTo({ left: positions[index], behavior: 'smooth' });
          }
          return;
        }

        const targetIndex = isMobile ? index : Math.min(index * perPage, this.slides.length - 1);
        const candidates = this.loopSlides.filter((slide) => Number(slide.dataset.loopIndex) === targetIndex);
        const target = candidates.length ? this.closestElement(candidates) : this.slides[targetIndex];
        if (!target) return;

        const targetLeft = this.getSlideScrollLeft(target);
        this.smoothScrollTo(targetLeft, 400);
      }

      smoothScrollTo(targetLeft, customDuration) {
        if (this.scrollAnimation) {
          cancelAnimationFrame(this.scrollAnimation);
          this.scrollAnimation = null;
        }

        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.viewport.scrollLeft = targetLeft;
          if (this.isInfinite) this.normalizeLoop();
          this.updatePagination();
          this.updateActiveSlide();
          return;
        }

        const startLeft = this.viewport.scrollLeft;
        const distance = targetLeft - startLeft;
        if (Math.abs(distance) < 1) {
          this.viewport.scrollLeft = targetLeft;
          if (this.isInfinite) this.normalizeLoop();
          this.updatePagination();
          this.updateActiveSlide();
          return;
        }

        const duration = customDuration || Math.min(500, Math.max(300, Math.abs(distance) * 1.3));
        this.isAnimating = true;
        this.viewport.classList.add('is-animating');
        const startTime = performance.now();
        const easeOut = (t) => Math.sin((t * Math.PI) / 2);

        const step = (now) => {
          const elapsed = now - startTime;
          const progress = Math.min(1, elapsed / duration);
          const eased = easeOut(progress);

          this.viewport.scrollLeft = startLeft + distance * eased;
          this.updateActiveSlide();

          if (progress < 1) {
            this.scrollAnimation = requestAnimationFrame(step);
          } else {
            this.viewport.scrollLeft = targetLeft;
            this.scrollAnimation = null;
            this.isAnimating = false;
            this.viewport.classList.remove('is-animating');
            if (this.isInfinite) {
              this.normalizeLoop();
            }
            this.updatePagination();
            this.updateActiveSlide();
          }
        };

        this.scrollAnimation = requestAnimationFrame(step);
      }

      onScroll() {
        if (this.isMobileGrid()) return;
        if (this.isInfinite && !this.pointer && !this.isAnimating && !this.isNormalizing) {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            if (this.isInfinite && !this.pointer && !this.isAnimating && !this.isNormalizing) {
              const closest = this.closestElement();
              if (closest && closest.hasAttribute('data-loop-clone')) {
                this.normalizeLoop();
              }
            }
          }, 150);
        }
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          this.updatePagination();
          this.updateActiveSlide();
        });
      }

    updatePagination() {
  const isMobile = window.innerWidth <= 749;

  if (this.isInfinite) {
    const closest = this.closestElement();

    if (!closest) return;

    const slideIndex = Number(closest.dataset.loopIndex);

    if (isNaN(slideIndex)) return;

    const { perPage } = this.getMetrics();

    const currentPage = isMobile
      ? Math.floor(slideIndex / perPage)
      : Math.min(
          Math.floor(slideIndex / perPage),
          (this.pageCount || 1) - 1
        );

    this.setActiveDot(currentPage);

  } else {
    const { positions } = this.getMetrics();

    if (isMobile) {
      const closest = this.closestElement(this.slides);

      if (closest) {
        const slideIndex = this.slides.indexOf(closest);
        const { perPage } = this.getMetrics();

        if (slideIndex !== -1) {
          this.setActiveDot(Math.floor(slideIndex / perPage));
        }
      }

    } else {
      const currentPage = positions.reduce((closest, position, index) => {
        const currentDistance = Math.abs(this.viewport.scrollLeft - position);
        const closestDistance = Math.abs(this.viewport.scrollLeft - positions[closest]);

        return currentDistance < closestDistance ? index : closest;
      }, 0);

      this.setActiveDot(currentPage);
    }
  }
}

      updateActiveSlide() {
        if (this.isMobileGrid()) return;
        const allCurrentSlides = Array.from(this.track?.querySelectorAll('[data-vzk-slider-slide]') || []);
        if (!allCurrentSlides.length) return;

        const viewportRect = this.viewport.getBoundingClientRect();
        const viewportFocal = viewportRect.left + viewportRect.width / 2;
        let closestSlide = null;
        let minDistance = Infinity;

        allCurrentSlides.forEach((slide) => {
          const slideRect = slide.getBoundingClientRect();
          const slideFocal = slideRect.left + slideRect.width / 2;
          const distance = Math.abs(slideFocal - viewportFocal);
          if (distance < minDistance) {
            minDistance = distance;
            closestSlide = slide;
          }
        });

        if (!closestSlide) return;
        if (this.activeSlide === closestSlide && closestSlide.classList.contains('is-active')) return;

        allCurrentSlides.forEach((slide) => {
          slide.classList.toggle('is-active', slide === closestSlide);
        });
        this.activeSlide = closestSlide;
      }

      setActiveDot(currentPage) {
        this.dots.querySelectorAll('.swiper-dots-vzk__dot').forEach((dot, index) => {
          const active = index === currentPage;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'page');
          else dot.removeAttribute('aria-current');
        });
      }

      onPointerEnter(event) {
        if (this.isMobileGrid()) return;
        const canDrag =
          this.dataset.dragEnabled === 'true' && (this.isInfinite ? this.slides.length > 1 : (this.pageCount || 0) > 1);
        if (!this.cursor || !canDrag || event.pointerType !== 'mouse') return;
        this.cursor.style.left = `${event.clientX}px`;
        this.cursor.style.top = `${event.clientY}px`;
        this.cursor.classList.add('is-visible');
      }

      onPointerLeave() {
        if (this.isMobileGrid()) return;
        if (this.cursor && !this.pointer?.dragging) {
          this.cursor.classList.remove('is-visible', 'is-dragging', 'is-hidden-interactive');
        }
      }

      onPointerDown(event) {
        if (this.isMobileGrid()) return;
        if (this.dataset.dragEnabled !== 'true' || event.pointerType !== 'mouse' || event.button !== 0) return;
        if (
          event.target.closest(
            '.vzk-product-card__quick-add, .vzk-product-card__form, .swiper-dots-vzk button, .yafa-ProductSlider__categories button, input, select, textarea'
          )
        )
          return;
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
        if (this.scrollAnimation) {
          cancelAnimationFrame(this.scrollAnimation);
          this.scrollAnimation = null;
          this.isAnimating = false;
          this.viewport.classList.remove('is-animating');
        }
        clearTimeout(this.scrollTimer);
        this.suppressClickUntil = 0;
        this.pointer = {
          id: event.pointerId,
          startX: event.clientX,
          startScroll: this.viewport.scrollLeft,
          dragging: false,
          lastX: event.clientX,
          lastTime: performance.now(),
          velocity: 0,
        };
        if (this.cursor && (this.isInfinite ? this.slides.length > 1 : (this.pageCount || 0) > 1)) {
          this.cursor.classList.add('is-dragging');
          this.cursor.classList.remove('is-hidden-interactive');
        }
      }

      onPointerMove(event) {
        if (this.isMobileGrid()) return;
        const canDrag =
          this.dataset.dragEnabled === 'true' && (this.isInfinite ? this.slides.length > 1 : (this.pageCount || 0) > 1);
        if (this.cursor && canDrag && event.pointerType === 'mouse') {
          this.cursor.style.left = `${event.clientX}px`;
          this.cursor.style.top = `${event.clientY}px`;
          if (!this.pointer?.dragging) {
            const isInteractive = event.target.closest(
              '.vzk-product-card__quick-add, .vzk-product-card__form, .swiper-dots-vzk button, .yafa-ProductSlider__categories button, input, select, textarea'
            );
            this.cursor.classList.toggle('is-hidden-interactive', !!isInteractive);
          }
        }

        const pointer = this.pointer;
        if (!pointer || pointer.id !== event.pointerId) return;
        const distance = event.clientX - pointer.startX;

        if (!pointer.dragging && Math.abs(distance) <= 6) return;

        if (!pointer.dragging) {
          pointer.dragging = true;
          this.suppressClickUntil = performance.now() + 500;
          this.viewport.classList.add('is-dragging');
          if (this.cursor && canDrag) {
            this.cursor.classList.add('is-dragging');
            this.cursor.classList.remove('is-hidden-interactive');
          }
          try {
            this.viewport.setPointerCapture(pointer.id);
          } catch (e) {}
        }

        event.preventDefault();

        const now = performance.now();
        const dt = now - pointer.lastTime;
        if (dt > 10) {
          const dx = event.clientX - pointer.lastX;
          pointer.velocity = 0.7 * (dx / dt) + 0.3 * (pointer.velocity || 0);
          pointer.lastX = event.clientX;
          pointer.lastTime = now;
        }

        this.viewport.scrollLeft = pointer.startScroll - distance;
        if (this.isInfinite) {
          this.normalizeLoop();
        }
        this.updatePagination();
      }

      onPointerUp(event) {
        if (this.isMobileGrid()) return;
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
        const { id, dragging, velocity = 0 } = this.pointer;
        this.pointer = null;

        if (this.cursor) {
          this.cursor.classList.remove('is-dragging');
          if (!this.viewport.matches(':hover')) {
            this.cursor.classList.remove('is-visible', 'is-hidden-interactive');
          }
        }

        try {
          if (this.viewport.hasPointerCapture(id)) {
            this.viewport.releasePointerCapture(id);
          }
        } catch (e) {}

        if (dragging) {
          this.suppressClickUntil = performance.now() + 400;
          this.viewport.classList.add('is-animating');
          this.viewport.classList.remove('is-dragging');

          const isMobile = window.innerWidth <= 749;
          const viewportRect = this.viewport.getBoundingClientRect();
          const focal = isMobile
            ? viewportRect.left + parseFloat(getComputedStyle(this.viewport).paddingLeft || 0)
            : viewportRect.left;
          const projectedDelta = -velocity * 160;
          const projectedFocal = focal + projectedDelta;

          if (this.isInfinite) {
            const targetSlide = this.closestElement(this.loopSlides, projectedFocal);
            if (targetSlide) {
              const targetLeft = this.getSlideScrollLeft(targetSlide);
              this.smoothScrollTo(targetLeft, 350);
            }
          } else {
            if (isMobile) {
              const targetSlide = this.closestElement(this.slides, projectedFocal);
              if (targetSlide) {
                const targetLeft = this.getSlideScrollLeft(targetSlide);
                this.smoothScrollTo(targetLeft, 350);
              }
            } else {
              const { positions } = this.getMetrics();
              const projectedScroll = this.viewport.scrollLeft + projectedDelta;
              const nearest = positions.reduce((closest, position, index) => {
                return Math.abs(projectedScroll - position) < Math.abs(projectedScroll - positions[closest])
                  ? index
                  : closest;
              }, 0);
              this.goToPage(nearest);
            }
          }
        } else {
          this.viewport.classList.remove('is-dragging');
        }
      }

      onKeyDown(event) {
        if (this.isMobileGrid()) return;
        if (event.target !== this.viewport || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (this.isInfinite) {
          const direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (direction !== 0) {
            const closest = this.closestElement();
            if (!closest) return;
            const currentIndex = Number(closest.dataset.loopIndex);
            const targetIndex = (currentIndex + direction + this.slides.length) % this.slides.length;
            const candidates = this.loopSlides.filter((s) => Number(s.dataset.loopIndex) === targetIndex);
            const target = candidates.length ? this.closestElement(candidates) : this.slides[targetIndex];
            if (target) {
              const targetLeft = this.getSlideScrollLeft(target);
              this.smoothScrollTo(targetLeft, 350);
            }
          }
        } else {
          const { positions, step } = this.getMetrics();
          if (event.key === 'Home') {
            this.goToPage(0);
          } else if (event.key === 'End') {
            this.goToPage(positions.length - 1);
          } else {
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            this.viewport.scrollBy({ left: direction * step, behavior: 'smooth' });
          }
        }
      }

      onClickCapture(event) {
        if (performance.now() < this.suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return false;
        }
      }

      onDragStart(event) {
        event.preventDefault();
      }
    }

    customElements.define('product-slider-vzk', ProductSliderVzk);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.container-header');
      this.isTransparentHeader = this.classList.contains('header-wrapper--transparent');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size' ||
        this.isTransparentHeader;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1200px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-container-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.updateTransparentHeaderState(window.pageYOffset || document.documentElement.scrollTop);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    updateTransparentHeaderState(scrollTop) {
      if (!this.isTransparentHeader || !this.header) return;

      const isScrolled = scrollTop > 10;
      this.header.classList.toggle('scrolled-past-header', isScrolled);
      this.classList.toggle('scrolled-past-header', isScrolled);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.updateTransparentHeaderState(scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-container-header-hidden', 'shopify-container-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-container-header-sticky', 'animate');
      this.header.classList.remove('shopify-container-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-container-header-hidden', 'shopify-container-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
